import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import {
  Box,
  Container
} from '@material-ui/core';

import SOListResults from 'components/SalesOrders/SOListResults';

const mapStateToProps = (state) => ({
  activeUserId: state.activeUserId,
  activeUserType: state.activeUserType,
  customers: state.customers,
  products: state.products,
  salesOrders: state.salesOrders,
  idGen: state.idGen,
  user: state.user
});

const SalesOrderList = (props) => (
  <>
    <Helmet>
      <title>Sales Orders | Duot Khayat</title>
    </Helmet>
    <Box
      sx={{
        backgroundColor: 'background.default',
        minHeight: '100%',
        py: 3
      }}
    >
      <Container maxWidth={false}>
        <SOListResults
          activeUserId={props.activeUserId}
          activeUserType={props.activeUserType}
          customers={props.customers}
          products={props.products}
          salesOrders={props.salesOrders}
          idGen={props.idGen}
          user={props.user}
        />
      </Container>
    </Box>
  </>
);

export default connect (mapStateToProps) (SalesOrderList);
